import { render, staticRenderFns } from "./SupportSubject.vue?vue&type=template&id=1aa42c7a"
import script from "./SupportSubject.vue?vue&type=script&lang=ts"
export * from "./SupportSubject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports